var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBatoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1d7e96",
      stroke: "#000000",
      strokeWidth: 0,
      fillOpacity: 1
    },
    id: "path1",
    cx: 18,
    cy: 18,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "26.8964px",
      lineHeight: 1.25,
      fontFamily: "'Akira Jimbo'",
      InkscapeFontSpecification: "'Akira Jimbo'",
      fill: "#ffffff",
      strokeWidth: 0.999999
    },
    d: "m 18.273359,-19.893629 q 0.941374,0.779995 0.941374,3.604117 0,0.67241 -0.215171,1.237235 -0.188275,0.537928 -0.511032,0.887581 -0.322757,0.322757 -0.726203,0.564824 -0.37655,0.242068 -0.779996,0.37655 -0.403446,0.107585 -0.726202,0.161378 -0.322757,0.05379 -0.537928,0.08069 H 15.529926 9.7203033 v -18.82748 h 5.5675547 q 1.586888,0 2.716537,1.129649 1.129649,1.129649 1.129649,2.716536 v 5.648244 q 0,1.34482 -0.860685,2.420677 z m -2.985501,-8.633745 h -2.286194 v 5.67514 q 0,0.914478 2.232401,1.102753 0.268964,0.0269 0.457239,-0.161379 0.161379,-0.161378 0.161379,-0.403446 v -5.648244 q 0,-0.242067 -0.161379,-0.403446 -0.161378,-0.161378 -0.403446,-0.161378 z m -0.268964,12.856479 q 1.075856,0 0.995167,-1.34482 -0.05379,-1.183441 -1.237234,-1.506198 -0.968271,-0.08069 -1.775163,-0.322757 v 3.173775 z",
    id: "text1",
    transform: "scale(1.2441664,-0.80375101)",
    "aria-label": "B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatoIcon);
export default __webpack_public_path__ + "static/media/bato-icon.6cf242c340105f7d0c45aea1dfcccf47.svg";
export { ForwardRef as ReactComponent };